import { why_constants } from "./constants";

export default function Why() {
  return (
    <section className="pb-10 md:py-10 bg-white">
      <div className="container  px-3">
        <div className="text-center mb-8 space-y-4">
          <h2 className="text-[22px] lg:text-[36px] font-bold text-black">
            {why_constants.title}
          </h2>
          <p className="text-[#222] text-sm md:text-xl max-w-[768px] mx-auto">
            {why_constants.description}
          </p>
        </div>

        <div className="space-y-[24px]">
          {why_constants.reasons.map((r, i) => (
            <div
              className="grid sm:grid-cols-2 gap-[24px] lg:gap-16"
              key={r.title}
            >
              <div
                className={`space-y-[18px] ${
                  i % 2 ? "md:order-last" : "md:order-first"
                }`}
              >
                <h3 className="text-[18px] lg:text-[32px] font-bold text-black ">
                  {r.title}
                </h3>

                <p className="text-[#222] text-sm">{r.description}</p>

                <div className="space-y-3">
                  {r.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <why_constants.CheckIcon />
                      <span className="text-[#222] text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className={`${i % 2 ? "md:order-first" : "md:order-last"}`}>
                <img src={r.image} alt={r.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
